export default __webpack_public_path__ + "table-of-contents-icon.svg";